import { useState } from "react";

import { Box, Checkbox, FormControlLabel, Modal, TextField, Typography } from "@mui/material";

import ProChip from "@/components/ProChip";
import SearchSelect from "@/components/SearchBar/SearchSelect";
import { AREA_CODES } from "@/constants/areaCode";
import useEvent from "@/hooks/useEvent";
import { validatePhoneNumber } from "@/utils/validatePhone";

interface FormPhoneItemProps {
  formData: {
    areaCode: string;
    phoneNumber: string;
    agreeReceiveSMS: boolean;
  };
  setFormData: (v: { areaCode?: string; phoneNumber?: string; agreeReceiveSMS?: boolean }) => void;
  show_upsell: boolean;
}

const areaCodeOptions = AREA_CODES.map((option) => ({
  value: option.dial_code,
  name: (
    <div className="flex space-x-[6px]">
      <span>{option.dial_code}</span>
      <span>-</span>
      <span>{option.flag}</span>
      <span>{option.name}</span>
    </div>
  ),
}));

export const validatePhone = (formData: FormPhoneItemProps["formData"]) => {
  if (formData.phoneNumber && formData.areaCode) {
    const phoneNumberStr = formData.areaCode + formData.phoneNumber;

    const countryCode = AREA_CODES.find(
      (item) => item.dial_code === formData.areaCode
    )?.country_code;
    const valid = validatePhoneNumber(phoneNumberStr, countryCode as CountryCode);

    return valid;
  }

  return false;
};

const FormPhoneItem = (props: FormPhoneItemProps) => {
  const { formData, show_upsell, setFormData } = props;

  const [visible, setVisible] = useState(false);

  const [error, setError] = useState(false);

  const validatePhone = useEvent(() => {
    if (formData.phoneNumber && formData.areaCode) {
      const phoneNumberStr = formData.areaCode + formData.phoneNumber;

      const countryCode = AREA_CODES.find(
        (item) => item.dial_code === formData.areaCode
      )?.country_code;
      const valid = validatePhoneNumber(phoneNumberStr, countryCode as CountryCode);

      return valid;
    }

    return false;
  });
  // return null;
  return (
    <div>
      <div className="mb-[20px] space-y-[10px] min-[700px]:flex min-[700px]:space-x-[10px] min-[700px]:space-y-0 min-[700px]:items-start">
        <div>
          <SearchSelect
            value={formData.areaCode}
            options={areaCodeOptions}
            onChange={(data) => {
              setFormData({ areaCode: data });
            }}
            border
            size="small"
            block
          />
        </div>
        <div className="w-full flex items-start">
          <TextField
            placeholder="Phone Number"
            variant="outlined"
            size="small"
            className="w-[100%]"
            value={formData.phoneNumber}
            error={error}
            onChange={(e) => {
              if (show_upsell) {
                setVisible(true);
                return;
              }

              setFormData({ phoneNumber: e.target.value });
            }}
            label={error ? "Invalid Number" : ""}
            onBlur={() => {
              if (formData.phoneNumber && formData.areaCode) {
                setError(!validatePhone());
                return;
              }

              setError(false);
            }}
          />
          <div className="mt-[6px]">
            <ProChip />
          </div>
        </div>
      </div>
      {validatePhone() && (
        <div className="flex flex-wrap items-center mt-[-15px] mb-[8px]">
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.agreeReceiveSMS}
                onChange={(_, checked) => {
                  if (show_upsell) {
                    setVisible(true);
                    return;
                  }
                  setFormData({ agreeReceiveSMS: checked });
                }}
              />
            }
            label={<div>I agree to receive SMS based on my data</div>}
          />
        </div>
      )}

      <Modal open={visible} onClose={() => setVisible(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            boxShadow: 2,
            borderRadius: "12px",
          }}
        >
          <Typography color="textPrimary">
            <ProChip />
            {" Feature - Receive SMS notifications and never miss a deal!"}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};
export default FormPhoneItem;
